import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "60px",
	height: "60px",
	preserveAspectRatio: "xMidYMid",
	style: {
		margin: "auto",
		background: "none",
		display: "block",
		shapeRendering: "auto",
		animationPlayState: "running",
		animationDelay: "0s"
	},
	viewBox: "0 0 100 100",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		r: 32,
		fill: "none",
		stroke: "#000000",
		strokeDasharray: "50.26548245743669 50.26548245743669",
		strokeLinecap: "round",
		strokeWidth: 8,
		style: {
			animationPlayState: "running",
			animationDelay: "0s"
		},
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			dur: "1s",
			keyTimes: "0;1",
			repeatCount: "indefinite",
			style: {
				animationPlayState: "running",
				animationDelay: "0s"
			},
			type: "rotate",
			values: "0 50 50;360 50 50"
		})
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		r: 23,
		fill: "none",
		stroke: "#aaaaaa",
		strokeDasharray: "36.12831551628262 36.12831551628262",
		strokeDashoffset: 36.12831551628262,
		strokeLinecap: "round",
		strokeWidth: 8,
		style: {
			animationPlayState: "running",
			animationDelay: "0s"
		},
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			dur: "1s",
			keyTimes: "0;1",
			repeatCount: "indefinite",
			style: {
				animationPlayState: "running",
				animationDelay: "0s"
			},
			type: "rotate",
			values: "0 50 50;-360 50 50"
		})
	})]
});
const ForwardRef = forwardRef(SvgLoading);
export default ForwardRef;
